import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import ContactUs from '../views/ContactUs';

const ContactUsPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <ContactUs locale={locale} />
    </Layout>
  );
};

ContactUsPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
    locales: PropTypes.shape({
      [PropTypes.string]: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default ContactUsPage;
